import {Component} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {environment} from '../environments/environment';

@Component({
    selector: 'ovn-customer-cabinet',
    standalone: false,
    template: '<router-outlet/>'
})

export class AppComponent {
    title = 'ovn-customer-cabinet';
    favIcon: HTMLLinkElement | null = document.querySelector('#favIcon');

    constructor(
        private titleService: Title
    ) {

        if (window.location.host === 'thegpstrack.com') {
            titleService.setTitle('The GPS Track');
        } else {
            if (environment.standaloneData.name) {
                titleService.setTitle(environment.standaloneData.name);
            }

            if (environment.standaloneData?.favicon && this.favIcon) {
                this.favIcon.href = environment.standaloneData.favicon;
            }
        }
    }
}
